import React, { forwardRef } from "react";
import Select from "react-select";
import makeAnimated from "react-select/animated";

const MultiSelect = forwardRef(
  (
    {
      data,
      onChange,
      onBlur,
      name,
      field,
      defaultValue,
      errors = {},
      touched = {},
      isLoading,
      isError,
      disabled,
    },
    ref
  ) => {
    return (
      <>
        <Select
          defaultValue={defaultValue}
          isDisabled={disabled}
          className='react-select-container'
          classNamePrefix='react-select'
          components={makeAnimated()}
          isMulti
          isSearchable
          options={data}
          ref={ref}
          isLoading={isLoading}
          noOptionsMessage={() => "Not Found!"}
          placeholder={<div>Select an option</div>}
          isClearable
          onBlur={onBlur}
          onChange={(value) => onChange(name, value)}
          name={name}
          styles={{
            control: (baseStyles, state) => ({
              ...baseStyles,
              borderColor: isError
                ? "#fa6684"
                : state.isFocused
                ? "#ccc"
                : "#ccc",
              boxShadow: state.isFocused ? 0 : 0,
              "& div": {
                lineHeight: "20px",
              },
              "&:hover": {
                borderColor: isError ? "#fa6684" : state.isFocused ? "#ccc" : 0,
              },
              height: 33, // set the height of the control
              minHeight: 30, // set the minimum height of the control
            }),
            valueContainer: (provided, state) => ({
              ...provided,
              height: 28, // set the height of the value container
              padding: "0px 3px", // set the padding of the value container
              marginBottom: "2.5px",
            }),
            multiValue: (baseStyles) => ({
              ...baseStyles,
              backgroundColor: "#727cf5",
              color: "#fff",
              lineHeight: "32px",
              padding: "0px",
            }),
            multiValueLabel: (baseStyles) => ({
              ...baseStyles,
              color: "#fff",
            }),
            indicatorsContainer: (baseStyles) => ({
              ...baseStyles,
              "& div": {
                color: isError ? "#fa5c7c" : null,
                lineHeight: "25px",
                padding: "0px 5px",
                "&:hover": {
                  color: isError ? "#fa5c7c" : null,
                },
              },
              "& span": {
                backgroundColor: isError && "#fa5c7c",
              },
            }),
          }}
        />
        {touched[name] && errors[name] ? (
          <div className='text-danger'>{errors[name]}</div>
        ) : null}
      </>
    );
  }
);

export default MultiSelect;
